import { createContext, useContext, useState, useCallback } from "react";

const PollingContext = createContext(null);

export function PollingProvider({ children }) {
  const [pollingJobs, setPollingJobs] = useState([]);

  const addPollingJob = useCallback((id, label, onReopen, phase) => {
    setPollingJobs(prev => {
      const existing = prev.find(j => j.id === id);
      if (existing) {
        return prev.map(j => j.id === id ? { ...j, label, onReopen, phase: phase || j.phase } : j);
      }
      return [...prev, { id, label, onReopen, phase: phase || null }];
    });
  }, []);

  const removePollingJob = useCallback((id) => {
    setPollingJobs(prev => prev.filter(j => j.id !== id));
  }, []);

  const updatePollingJob = useCallback((id, updates) => {
    setPollingJobs(prev =>
      prev.map(j => j.id === id ? { ...j, ...updates } : j)
    );
  }, []);

  const isPolling = pollingJobs.length > 0;

  return (
    <PollingContext.Provider value={{ pollingJobs, isPolling, addPollingJob, removePollingJob, updatePollingJob }}>
      {children}
    </PollingContext.Provider>
  );
}

export function usePolling() {
  const ctx = useContext(PollingContext);
  if (!ctx) throw new Error("usePolling must be used inside PollingProvider");
  return ctx;
}

export const BackgroundTaskProvider = PollingProvider;
export const useBackgroundTasks = usePolling;
